/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Show_ProofInputs */

const en_about_show_proof = /** @type {(inputs: About_Show_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show proof`)
};

const ar_about_show_proof = /** @type {(inputs: About_Show_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعرض الإثبات`)
};

const bn_about_show_proof = /** @type {(inputs: About_Show_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাজের প্রমাণ দেখুন`)
};

const de_about_show_proof = /** @type {(inputs: About_Show_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beweise ansehen`)
};

const es_about_show_proof = /** @type {(inputs: About_Show_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver pruebas`)
};

const fr_about_show_proof = /** @type {(inputs: About_Show_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les preuves`)
};

const pt_about_show_proof = /** @type {(inputs: About_Show_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver resultados`)
};

const zh_about_show_proof = /** @type {(inputs: About_Show_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出示证明`)
};

const tr_about_show_proof = /** @type {(inputs: About_Show_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanıtı göster`)
};

const ru_about_show_proof = /** @type {(inputs: About_Show_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Покажите доказательства`)
};

const pl_about_show_proof = /** @type {(inputs: About_Show_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż dowód`)
};

/**
* | output |
* | --- |
* | "Show proof" |
*
* @param {About_Show_ProofInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_show_proof = /** @type {((inputs?: About_Show_ProofInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Show_ProofInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_show_proof(inputs)
	if (locale === "bn") return bn_about_show_proof(inputs)
	if (locale === "de") return de_about_show_proof(inputs)
	if (locale === "es") return es_about_show_proof(inputs)
	if (locale === "fr") return fr_about_show_proof(inputs)
	if (locale === "pt") return pt_about_show_proof(inputs)
	if (locale === "zh") return zh_about_show_proof(inputs)
	if (locale === "tr") return tr_about_show_proof(inputs)
	if (locale === "ru") return ru_about_show_proof(inputs)
	if (locale === "pl") return pl_about_show_proof(inputs)
	return en_about_show_proof(inputs)
});